export default __webpack_public_path__ + "static/media/element_27.72b0f4af.webp";